<template>
  <div>
    <div
      style="
        display: flex;
        margin-top: 20px;
        margin-bottom: 20px;
        padding-left: 20px;
        padding-right: 20px;
      "
    >
      <div style="flex: 8; margin-right: 20px">
        <div class="title">
          {{ record.title }}
        </div>

        <div style="margin-bottom: 10px">
          <span key="like-o">
            <a-icon type="star-o" style="margin-right: 8px" />
            {{ record.thumbCount }}{{ $t("新闻明细.点赞") }}
          </span>
          <span key="eye">
            <a-icon type="eye" style="margin-right: 8px" />
            {{ record.browseCount }}{{ $t("新闻明细.浏览") }}
          </span>
        </div>
        <div>
          <div class="description" style="margin-left: 30px; font-size: 14px">
            {{ record.keywords }}
          </div>
        </div>
        <div
          style="
            display: flex;
            justify-content: center;
            margin-bottom: 40px;
            margin-top: 30px;
          "
        >
          <img :src="record.avatar" width="auto" height="400px" />
        </div>
        <div style="margin-bottom: 10px">
          <div style="white-space: pre-wrap">
            <span style="font-size: 18px" v-html="record.content"></span>
          </div>
        </div>

        <div style="display: flex; justify-content: center">
          <a-button
            size="large"
            type="primary"
            icon="like"
            :disabled="disabled"
            @click="updataData(record.id)"
            >{{ $t("新闻明细.点赞") }}({{ record.thumbCount }})</a-button
          >
        </div>
        <div></div>

        <div class="font-size">{{ $t("新闻明细.本文标签") }}：无</div>
        <div class="font-size">
          {{ $t("新闻明细.浏览次数") }}：{{ record.browseCount
          }}{{ $t("新闻明细.次浏览") }}
        </div>
        <div class="font-size">
          {{ $t("新闻明细.发布日期") }}：{{ record.createTime }}
        </div>
      </div>
      <div style="flex: 2">
        <right-mode style="padding-left: 40px"></right-mode>
      </div>
    </div>
  </div>
</template>

<script>
import RightMode from "../model/rightMode.vue";
import axios from "axios";
export default {
  components: { RightMode },
  data() {
    return {
      record: {},
      disabled: false,
    };
  },

  mounted() {
    console.log("this.$route.query.id======", this.$route.query.id);
    const id = this.$route.query.id;
    if (id) {
      this.queryData(id);
      this.update_browseCount(id);
    } else {
      this.$router.push({
        path: "/newsList",
      });
    }
    // console.log("this.$route.query====", this.$route.query);
  },
  methods: {
    update_browseCount(id) {
      axios({
        url: this.$apiUrl + "/api/general/update_browseCount",
        method: "POST",
        data: {
          tableName: "jf_web_basicInfo",
          id: id,
        },
      }).then((res) => {
        // console.log("res.data=======", res.data);
        this.record.browseCount = this.record.browseCount * 1 + 1;
      });
    },
    queryData(id) {
      axios({
        url: this.$apiUrl + "/api/general/querySingle",
        method: "POST",
        data: {
          tableName: "jf_web_basicInfo",
          id: id,
        },
      }).then((res) => {
        console.log("res.data=======", res.data);
        this.record = res.data.data;
      });
    },
    updataData(id) {
      axios({
        url: this.$apiUrl + "/api/general/updateSingle",
        method: "POST",
        data: {
          tableName: "jf_web_basicInfo",
          record: {
            id: id,
            thumbCount: parseInt(this.record.thumbCount, 10) + 1,
          },
          logRequired: false,
        },
      }).then((res) => {
        this.record.thumbCount = parseInt(this.record.thumbCount, 10) + 1;
        this.disabled = true;
      });
    },
  },
};
</script>

<style scoped>
.title {
  margin: 0;
  font-size: 1.65em;
  line-height: 1.45;
  margin-bottom: 15px;
  color: #444;
  text-align: center;
}
.description {
  color: #222222;
  font-family: arial;
  font-size: 18px;
  white-space: normal;
  background-color: #ffffff;
}
.font-size {
  line-height: 26px;
  padding-bottom: 5px;
}
</style>
